jQuery.ajaxPrefilter(function (s) {
    if (s.crossDomain) {
        s.contents.script = false;
    }
});

function inViewport(elem, callback) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var observer = new IntersectionObserver(function (entries, self) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                callback(entry);
                self.unobserve(entry.target);
            }
        });
    }, options);

    document.querySelectorAll(elem).forEach(function (v) {
        observer.observe(v);
    });
}

// Lazy Load Videos
window.addEventListener('DOMContentLoaded', function () {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    function lazyLoadVideos() {
        lazyVideos.forEach(function (lazyVideo) {
            observer.observe(lazyVideo);
        });
    }

    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    observer.unobserve(video.target);
                }
            });
        });

        // Check if connection in navigator global
        if (navigator.connection) {
            // If SaveData is false, proceed
            if (navigator.connection.saveData === false) {
                // Check effectiveType and is 4g
                if (navigator.connection.effectiveType && navigator.connection.effectiveType === '4g') {
                    lazyLoadVideos();
                }
            }
        } else {
            lazyLoadVideos();
        }
    }
});

// InViewport jQuery plugin
(function ($, win) {
    $.fn.inViewport = function (cb) {
        return this.each(function (i, el) {
            function visPx() {
                var H = $(this).height(),
                    r = el.getBoundingClientRect(),
                    t = r.top,
                    b = r.bottom;
                return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
            }
            visPx();
            $(win).on("resize scroll", visPx);
        });
    };
}(jQuery, window));

(function ($, win) {
    $.fn.elementIsVisible = function (cb) {
        return this.each(function (i, el) {
            function visPx() {
                var H = $(this).height(),
                    r = el.getBoundingClientRect(),
                    t = r.top,
                    b = r.bottom;
                return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
            }
            visPx();
            $(win).on("resize scroll", visPx);
        });
    };
}(jQuery, window));

var debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        if (immediate && !timeout) func.apply(context, args);
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Lazy load background image
document.addEventListener("DOMContentLoaded", function () {
    var bgObserver = new IntersectionObserver(function (entries, imgObserver) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var lazy = entry.target;
                //console.log("lazy loading ", lazy);
                lazy.style.backgroundImage = "url(" + lazy.getAttribute('data-bg-src') + ")";
                lazy.removeAttribute('data-bg-src');
                imgObserver.unobserve(lazy);
            }
        });
    });

    var arr = document.querySelectorAll('[data-bg-src]');
    arr.forEach(function (v) {
        bgObserver.observe(v);
    });

});

// Form validation
/* (function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {

            form.addEventListener('submit', function (event) {
                // Stop propagating the form if contains invalid elements
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');

                // Loop invalid elements and add invalid feedback text
                for (var i = 0; i < form.elements.length; i++) {
                    // If form element is invalid, update feedback text
                    var currFormElement = form.elements[i];

                    if (!currFormElement.checkValidity()) {
                        var feedback = jQuery('.invalid-feedback', jQuery(currFormElement).parent());
                        if (!feedback.attr('data-label')) {
                            feedback.text(currFormElement.validationMessage);
                        } else {
                            feedback.text(feedback.attr('data-label'));
                        }
                    }
                }
            }, false);
        });
    }, false);
})(); */

var ACTDIG = ACTDIG || (ACTDIG = {});
ACTDIG.Funcs = (function ($, window, document) {
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results[1] || 0;
    };

    /**
     * Move the owl prev/next inline with owl-dots
     */
    function owl() {

        $('.owl-carousel').each(function () {
            var $self = $(this);

            if ($self.hasClass('owl-nav-float')) {
                return;
            }

            if ($self.find('.owl-newnav').length == 0) {
                $self.find('.owl-dots')
                    .wrap('<div class="owl-newnav"></div>');

                $self.find('.owl-nav')
                    .find('.owl-prev')
                    .prependTo($self.find('.owl-newnav'));

                $self.find('.owl-nav')
                    .find('.owl-next')
                    .appendTo($self.find('.owl-newnav'));
            }

            var $newnav = $self.find('.owl-newnav');
            if ($self.find('.owl-nav').hasClass('disabled')) {
                $newnav.addClass('nav-disabled');
            } else {
                $newnav.removeClass('nav-disabled');
            }

            if ($self.find('.owl-dots').hasClass('disabled')) {
                $newnav.addClass('dots-disabled');
            } else {
                $newnav.removeClass('dots-disabled');
            }
        });

    }

    /**
     * Smooth scroll links on page
     */
    function dataScroll() {
        // var pad = $(window).width() < 992 ? 60 : 100;
        $('a[data-scroll]').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') ||
                location.hostname == this.hostname) {

                var target = $(this.hash);
                var offset = 20;
                // var offset = $('header.master').height() + pad;

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (typeof $(this).data('offset') !== 'undefined') {
                    offset = $(this).data('offset');
                }

                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - offset
                    }, 1000);
                    return false;
                }
            }
        });
    }

    function owlStuff() {
        // Owl nav
        var owlResize = debounce(function () {
            owl();
        }, 0);

        $(window).on('resize', owlResize);
        owlResize();
    }

    return {
        init: function () {
            dataScroll();
            //owlStuff();

            $("[data-watch]").elementIsVisible(function (px) {
                if (px) $(this).addClass("loaded");
            });

            $('select.placeholder').on('change', function (e) {
                $(this).removeClass('placeholder');
            });

            $('[data-toggle="popover"]').popover({
                container: 'body',
                //trigger: 'focus'
            });

            $('#contactModal').on('show.bs.modal', function (event) {
                var target = $(event.relatedTarget);
                var title = target.data('modal-title');
                var enquirySubject = target.data('form-enquiry');
                var message = target.data('form-message');

                var modal = $(this);
                modal.find('.modal-body h2').text(title);
                modal.find('[name=Enquiry_Type]').val(enquirySubject);
                modal.find('[name=Message]').html(message);
            });

            ma5menu({
                menu: '.site-menu',
                activeClass: 'active',
                footer: '#ma5menu-tools',
                position: 'left',
                closeOnBodyClick: true
            });

            $('html').on('click', function (e) {
                if (typeof $(e.target).data('original-title') == 'undefined' && !$(e.target).parents().is('.popover.in')) {
                    $('[data-original-title]').popover('hide');
                }
            });
        },
        owl: function () {
            owl();
        }
    };
})(window.jQuery, window, document);

function triggerRefresh() {
    var evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
}

(function ($, window, document) {
    function animateCount(element) {
        var _element = element.target;

        var $this = $(_element);

        var _duration = $this.is('[data-duration]') ? $this.data('duration') : 2000;

        setTimeout(function () {
            $this.prop('Counter', 0).animate({
                Counter: $this.data('count')
            }, {
                duration: _duration,
                easing: 'swing',
                step: function (now) {
                    if ($this.is('[data-format]')) {
                        if ($this.attr('data-format') == 'currency') {
                            $this.text(now.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                        } else {
                            $this.text(Math.ceil(now).toLocaleString(undefined));
                        }
                    } else {
                        $this.text(Math.ceil(now));
                    }
                },
                /* complete : function(){
                    if($this.is('[data-format]')) {
                        $this.text(Math.ceil($this.text()).toLocaleString('en'));
                    }
                } */
            });
        }, 400);
    }

    window.addEventListener('DOMContentLoaded', function () {
        inViewport('[data-countin]', function (element) {
            animateCount(element);
        }, {
            threshold: [1],
        });
    });
})(window.jQuery, window, document);

(function ($, window, document) {
    function scrollToTop() {
        var $btn = $('#scrollToTop');

        var offset = 600;

        $btn.on('click', function (e) {
            e.preventDefault();

            $('html,body').animate({
                scrollTop: 0
            }, 1000);
            return false;
        });

        // When the user scrolls down 20px from the top of the document, show the button
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.body.scrollTop > offset || document.documentElement.scrollTop > offset) {
                $btn.addClass('is-visible');
            } else {
                $btn.removeClass('is-visible');
            }
        }
    }

    window.addEventListener('DOMContentLoaded', function () {
        scrollToTop();
    });
})(window.jQuery, window, document);